import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";
import {useSelector} from "react-redux";

export const useDostepneStatusy = (sprawozdanieId, enabled = true) => {
    const rola = useSelector((state) => state.user.role);
    const roleParam = rola === 'oper' ? 'oper/' : '';

    return useQuery({
        queryKey: [`dostepne_statusy`, sprawozdanieId],
        queryFn: () => getData(`/${roleParam}sprawozdanie/dostepne-statusy/${sprawozdanieId}`),
        enabled: enabled && !!sprawozdanieId
    })
}
